<template>
  <div>

    <el-row type="flex" align="middle" class="homeSearch">
      <el-col :span="5">
        <el-select v-model="field" @change="fieldChange">
          <el-option
            v-for="item in fields"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="15">
        <el-input v-show="this.field==='accession'" placeholder="e.g.,OBIA0001;I000001;S00000001" v-model="accession"></el-input>
        <el-select v-show="this.field!=='accession'" v-model="result" style="width:100%;">
          <el-option
            v-for="item in results"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>

      <el-col :span="3">
        <div style="display: flex;">
          <span style="margin-left: 2px;">
            <el-upload
              action=""
              :show-file-list="false"
              :before-upload="beforeUpload"
              :http-request="uploadImage"
              >
              <el-button slot="trigger" type="home-icon"><i class="el-icon-camera" style="font-size: 24px;"></i></el-button>
            </el-upload>
          </span>
          <span style="margin-left: 2px;">
            <el-button type="home-icon" @click.prevent="submit"><i class="el-icon-search" style="font-size: 24px;"></i></el-button>
          </span>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="15" :offset="5">
        <div style="text-align: left; color: white;margin-top: 5px;">
          Search image:
          <!-- <a style="color:#dadde3" href="/static/img/example.b6a920e.png" download="example.png" target="_blank">example<i class="el-icon-bottom"></i></a> -->
          <el-button type="download-example" @click="downloadExampleImage">example<i class="el-icon-bottom"></i></el-button>
        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import { getLeftMenu } from '@/api'
import examplePNG from '@/assets/home/example.png'
// import exampleDICOM from '@/assets/home/DICOM.dcm'

export default {
  name: 'Search',

  components: {},
  props: {},
  data () {
    return {

      examplePng: examplePNG,

      // input 框
      accession: '',

      // 下拉框 1
      fields: [{
        value: 'accession',
        label: 'Accession'
      }, {
        value: 'disease',
        label: 'Disease'
      }, {
        value: 'modality',
        label: 'Modality'
      }, {
        value: 'anatomicalSite',
        label: 'Anatomical Site'
      // }, {
      //   value: 'manufacturer',
      //   label: 'Manufacturer'
      }],

      // 下拉框 1
      field: 'accession',

      // 下拉框 2
      result: '',

      // 下拉框 2
      results: [],
      diseaseItems: [],
      modalityItems: [],
      anatomicalSiteItems: [],
      // manufacturerItems: [],

      // 检索字段
      searchFields: {
        collectionAccession: '',
        individualAccession: '',
        studyAccession: '',
        disease: '',
        ageMin: 0,
        ageMax: 100,
        gender: '',
        modality: [],
        isModalityAll: 0,
        isAnatomicalSiteAll: 0,
        anatomicalSite: [],
        manufacturer: ''
      }
    }
  },
  watch: {},
  computed: {},
  methods: {
    // 下拉框 1 改变
    fieldChange () {
      const val = this.field
      switch (val) {
        case 'disease':
          this.getResults(this.diseaseItems)
          break
        case 'modality':
          this.getResults(this.modalityItems)
          break
        case 'anatomicalSite':
          this.getResults(this.anatomicalSiteItems)
          break
        // case 'manufacturer':
        //   this.getResults(this.manufacturerItems)
        //   break
      }
    },

    getResults (arr) {
      var newArr = []
      for (var i = 0; i < arr.length; i++) {
        var item = {}
        item.value = arr[i]
        item.label = arr[i]
        newArr.push(item)
      }
      this.results = newArr
      this.result = arr[0]
    },

    // 提交
    submit () {
      const val = this.field
      switch (val) {
        case 'accession':
          this.accessionChange()
          break
        case 'disease':
          this.searchFields.disease = this.result
          this.searchFields.modality = []
          this.searchFields.anatomicalSite = []
          this.searchFields.manufacturer = ''
          this.toBrowse()
          break
        case 'modality':
          this.searchFields.disease = ''
          this.searchFields.modality.push(this.result)
          this.searchFields.anatomicalSite = []
          this.searchFields.manufacturer = ''
          this.toBrowse()
          break
        case 'anatomicalSite':
          this.searchFields.disease = ''
          this.searchFields.modality = []
          this.searchFields.anatomicalSite.push(this.result)
          this.searchFields.manufacturer = ''
          this.toBrowse()
          break
        // case 'manufacturer':
        //   this.searchFields.disease = ''
        //   this.searchFields.modality = []
        //   this.searchFields.anatomicalSite = []
        //   this.searchFields.manufacturer = this.result
        //   this.toBrowse()
        //   break
      }
    },

    // accession input
    accessionChange () {
      const val = this.accession.trim().toUpperCase()
      if (val.match(/^OBIA[0-9]{4}$/)) {
        this.searchFields.collectionAccession = val
        this.searchFields.individualAccession = ''
        this.searchFields.studyAccession = ''
        this.toBrowse()
      } else if (val.match(/^I+[0-9]{6}$/)) {
        this.searchFields.collectionAccession = ''
        this.searchFields.individualAccession = val
        this.searchFields.studyAccession = ''
        this.toBrowse()
      } else if (val.match(/^S+[0-9]{8}$/)) {
        this.searchFields.collectionAccession = ''
        this.searchFields.individualAccession = ''
        this.searchFields.studyAccession = val
        this.toBrowse()
      } else if (val === '') {
        this.$message('Accession can not be empty !')
      } else {
        this.$message('Accession error !')
      }
    },

    // 跳转 browse
    toBrowse () {
      const searchFields = this.searchFields
      this.$router.push({
        path: '/browse',
        name: 'Browse',
        params: {
          searchFields: searchFields
        }
      })
    },

    // 获取下拉框 2 值
    async initialization () {
      const data = await getLeftMenu()
      if (data.success) {
        var resp = data.data
        this.diseaseItems = resp.disease
        this.modalityItems = resp.modality
        this.anatomicalSiteItems = resp.anatomicalSite
        // this.manufacturerItems = resp.manufacturer
      }
    },

    // 上传前对类型大小的验证
    beforeUpload (file) {
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.'))
      const isRight = fileType === '.jpg' || fileType === '.png' || fileType === '.dcm'
      const isLt15M = file.size / 1024 / 1024 < 15
      if (!isRight) {
        this.$message.error('The uploaded image format can only be JPG/PNG/DICOM !')
      }
      if (!isLt15M) {
        this.$message.error('The uploaded image size cannot exceed 15MB !')
      }
      return isRight && isLt15M
    },

    // 上传图片
    uploadImage (param) {
      // this.searchImage = param.file
      // 带上参数 去 search image
      // console.log(param)
      this.$router.push({
        path: '/search-image',
        name: 'SearchImage',
        params: {
          searchImage: param.file
        }
      })
    },

    // 这个会重命名文件
    // downloadExampleImage () {
    //   console.log(examplePNG)
    //   window.open(examplePNG, '_blank')
    // }

    downloadExampleImage () {
      const a = document.createElement('a')
      a.href = this.examplePng
      a.setAttribute('download', 'example.png')
      a.click()
      a.remove()
    }

  },
  created () {},
  mounted () {
    this.initialization()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/home/Search.vue